import React from "react";
import axios from "axios";
import moment from "moment";
import { withRouter } from "next/router";

import BaseLayout from "../components/layouts/BaseLayout";
import PerMonthStats from "../components/stats/PerMonthStats";
import PerWeekdayStats from "../components/stats/PerWeekdayStats";
import PerDepartmentStats from "../components/stats/PerDepartmentStats";
import PerPeriodStats from "../components/stats/PerPeriodStats";
import PerResourceStats from "../components/stats/PerResourceStats";
import PerCampusStats from "../components/stats/PerCampusStats";
import DateRange from "../components/shared/DateRange";

const getTotalStats = async params => {
  try {
    const { data } = await axios.get(`${process.env.BACKEND_URL}/stats/total`, { params });
    return data.stats;
  } catch (e) {
    return [];
  }
};

const getPerMonthStats = async params => {
  try {
    const { data } = await axios.get(`${process.env.BACKEND_URL}/stats/perMonth`, { params });
    return data.stats;
  } catch (e) {
    return [];
  }
};

const getPerWeekStats = async params => {
  try {
    const { data } = await axios.get(`${process.env.BACKEND_URL}/stats/perWeekDay`, { params });
    return data.stats;
  } catch (e) {
    return [];
  }
};

const getPerDepartmentStats = async params => {
  try {
    const { data } = await axios.get(`${process.env.BACKEND_URL}/stats/perDepartment`, { params });
    return data.stats;
  } catch (e) {
    return [];
  }
};

const getPerPeriodStats = async params => {
  try {
    const { data } = await axios.get(`${process.env.BACKEND_URL}/stats/perPeriod`, { params });
    return data.stats;
  } catch (e) {
    return [];
  }
};

const getPerResourceStats = async params => {
  try {
    const { data } = await axios.get(`${process.env.BACKEND_URL}/stats/perResource`, { params });
    return data.stats;
  } catch (e) {
    return [];
  }
};

const getPerCampusStats = async params => {
  try {
    const { data } = await axios.get(`${process.env.BACKEND_URL}/stats/perCampus`, { params });
    return data.stats;
  } catch (e) {
    return [];
  }
};

class Stats extends React.Component {
  static async getInitialProps({ query }) {
    const params = {
      ...query
    };

    const [totalStats, perMonthStats, perWeekStats, perDepartmentStats, perPeriodStats, perResourceStats, perCampusStats] = await Promise.all([
      getTotalStats(params),
      getPerMonthStats(params),
      getPerWeekStats(params),
      getPerDepartmentStats(params),
      getPerPeriodStats(params),
      getPerResourceStats(params),
      getPerCampusStats(params)
    ]);

    return {
      totalStats,
      perMonthStats,
      perWeekStats,
      perDepartmentStats,
      perPeriodStats,
      perResourceStats,
      perCampusStats
    };
  }

  handleChangeDateRange = dateRange => {
    const { query: lastQuery } = this.props.router;
    this.props.router.push({
      pathname: "/estatisticas",
      query: { 
        ...lastQuery, 
        startDate: dateRange.startDate.format("YYYY-MM-DD"),
        endDate: dateRange.endDate.format("YYYY-MM-DD"),
      }
    });
  };

  render() {
    const { totalStats, perMonthStats, perWeekStats, perDepartmentStats, perResourceStats, perPeriodStats, perCampusStats } = this.props;
    const { query } = this.props.router;

    let startDate = null;
    let endDate = null;

    if (query.startDate) {
      startDate = query.startDate;
    } else {
      const now = moment();
      startDate = now.subtract(7, 'days').format("YYYY-MM-DD");
    }
  
    if (query.endDate) {
      endDate = query.endDate;
    } else {
      const now = moment();
      endDate = now.format("YYYY-MM-DD");
    }

    const startDateDisplay = moment(startDate).format("DD/MM/YYYY");
    const endDateDisplay = moment(endDate).format("DD/MM/YYYY");

    return (
      <BaseLayout>
        <section className="section">
        
          <br />
          <h1 className="title is-size-1 is-size-3-mobile is-size-2-tablet has-text-centered">
            Estatísticas do Serviço de Videoconferências
          </h1>

          <br />
          <br />
          <DateRange startDate={startDate} endDate={endDate} onChangeDateRange={this.handleChangeDateRange} />
          <br />
          <br />

          {totalStats && (
            <div className="columns">
              <div className="column">
                <div className="box has-text-centered">
                  <div className="title is-1">
                    {totalStats.used}
                  </div>
                  <div className="subtitle is-6">
                    Número de reservas utilizadas
                  </div>
                </div>
              </div>

              <div className="column">
                <div className="box has-text-centered">
                  <div className="title is-1">
                    {totalStats.not_used}
                  </div>
                  <div className="subtitle is-6">
                    Número de reservas não utilizadas
                  </div>
                </div>
              </div>

              <div className="column">
                <div className="box has-text-centered">
                  <div className="title is-1">
                    {totalStats.canceled}
                  </div>
                  <div className="subtitle is-6">
                    Número de reservas canceladas
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="columns">
            <div className="column">
              <div className="box">
                <h4 className="title is-4">
                  Número de reuniões realizadas no período de {startDateDisplay} a {endDateDisplay} por dia da semana:
                </h4>
                {perWeekStats.length > 0 ? (
                  <PerWeekdayStats data={perWeekStats} />
                ) : (
                  <div>
                    <div className="notification">Não há dados para serem mostrados.</div>
                    <br />
                  </div>
                )}
              </div>
            </div>
            {/* .column */}

          
            <div className="column">
              <div className="box">
                <h4 className="title is-4">
                  Número de reuniões realizadas no período de {startDateDisplay} a {endDateDisplay} por período:
                </h4>
                {perPeriodStats.length > 0 ? (
                  <PerPeriodStats data={perPeriodStats} />
                ) : (
                  <div>
                    <div className="notification">Não há dados para serem mostrados.</div>
                    <br />
                  </div>
                )}
              </div>
            </div>
            {/* .column */}
          </div>
          {/* .columns */}
              

          <div className="columns">
            <div className="column">
              <div className="box">
                <h4 className="title is-4">
                  Reuniões realizadas no período de {startDateDisplay} a {endDateDisplay} por mês:
                </h4>
                {perMonthStats.length > 0 ? (
                  <PerMonthStats data={perMonthStats} />
                ) : (
                  <div>
                    <div className="notification">Não há dados para serem mostrados.</div>
                    <br />
                  </div>
                )}
              </div>
            </div>
            {/* .column */}
          </div>
          {/* .columns */}

          <div className="columns">
            <div className="column">
              <div className="box">
                <h4 className="title is-4">
                  Número de reuniões realizadas no período de {startDateDisplay} a {endDateDisplay} por unidade:
                </h4>
                {perDepartmentStats.length > 0 ? (
                  <PerDepartmentStats data={perDepartmentStats} />
                ) : (
                  <div>
                    <div className="notification">Não há dados para serem mostrados.</div>
                    <br />
                  </div>
                )}
              </div>
            </div>
            {/* .column */}
          </div>
          {/* .columns */}

          <div className="columns">
            <div className="column">
              <div className="box">
                <h4 className="title is-4">
                  Número de reuniões realizadas no período de {startDateDisplay} a {endDateDisplay} por salas:
                </h4>
                {perResourceStats.length > 0 ? (
                  <PerResourceStats data={perResourceStats} />
                ) : (
                  <div>
                    <div className="notification">Não há dados para serem mostrados.</div>
                    <br />
                  </div>
                )}
              </div>
            </div>
            {/* .column */}
          </div>
          {/* .columns */}          

          <div className="columns">
            <div className="column">
              <div className="box">
                <h4 className="title is-4">
                  Número de reuniões realizadas no período de {startDateDisplay} a {endDateDisplay} por campus:
                </h4>
                {perCampusStats.length > 0 ? (
                  <PerCampusStats data={perCampusStats} />
                ) : (
                  <div>
                    <div className="notification">Não há dados para serem mostrados.</div>
                    <br />
                  </div>
                )}
              </div>
            </div>
            {/* .column */}
          </div>
          {/* .columns */}

        </section>

        <style jsx>{`
          .box .title {
            margin-top: 5px;
            margin-bottom: 40px;
          }

          .filter-form {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: flex-start;
            align-items: center;
            align-content: space-around;
          }

          .filter-form-item {
            margin-bottom: 1rem;
          }
        `}</style>
      </BaseLayout>
    );
  }
}

export default withRouter(Stats);



// WEBPACK FOOTER //
// pages/estatisticas.js